import { Application } from "@hotwired/stimulus";

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

export { application };

// Import and register all TailwindCSS Components
import { Alert } from "tailwindcss-stimulus-components";
application.register("alert", Alert);

import Dialog from '@stimulus-components/dialog'
application.register('dialog', Dialog)